import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import SEOJsonLD from "../../components/feature/SEOJsonLD";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import PlansSection from "./components/PlansSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <div className="min-h-screen font-['Open_Sans']">
      <SEOJsonLD />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <PlansSection />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
